import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommControlLookup extends Layout {
    sourceMCControl: DataSource;
    tableMobileCommControlLookup: Table;
}
